import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CurrencyInputDirective } from './currency.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [
    CurrencyInputDirective
  ],
  exports: [
    CurrencyInputDirective
  ]
})
export class CurrencyInputModule {
}
